/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import ResizeWrapper from '@/components/ResizeWrapper';
import { useIsMobile } from '@/utils/utils';
import MainArea from './MainArea';
import { ABORT_VISIBILITY_CHANGE, useLeave } from '@/lib/useCommon';
import { getRouteInteractionMode } from '@/lib/interactionExperience';
import { refreshSceneRuntime } from '@/lib/sceneRuntime';
import {
  updateInteractionMode,
} from '@/store/slices/room';
import styles from './index.module.less';

export default function () {
  const leaveRoom = useLeave();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    refreshSceneRuntime(dispatch);
    const isOriginalDemo = window.location.host.startsWith('localhost');
    const handler = () => {
      if (
        document.visibilityState === 'hidden' &&
        !sessionStorage.getItem(ABORT_VISIBILITY_CHANGE)
      ) {
        leaveRoom();
      }
    };
    !isOriginalDemo && document.addEventListener('visibilitychange', handler);
    return () => {
      !isOriginalDemo && document.removeEventListener('visibilitychange', handler);
    };
  }, []);

  useEffect(() => {
    dispatch(
      updateInteractionMode({
        interactionMode: getRouteInteractionMode(location.pathname),
        persist: false,
      })
    );
  }, [dispatch, location.pathname]);

  return (
    <ResizeWrapper className={styles.container}>
      <Header />
      <div
        className={styles.main}
        style={{
          padding: 0,
        }}
      >
        <div className={`${styles.mainArea} ${useIsMobile() ? styles.isMobile : ''}`}>
          <MainArea />
        </div>
        {useIsMobile() ? null : null}
      </div>
    </ResizeWrapper>
  );
}
